import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { useState } from "react";
import Election from "./containers/Election";
import ElectionHeader from "./containers/ElectionHeader";
import Members from "./containers/Members";
import MembersHeader from "./containers/MembersHeader";
import logo from "./logo.png";

const tabs = ["election", "membership"];

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function App() {
  const [tab, setTab] = useState("election");
  const [search, setSearch] = useState("");

  const client = new ApolloClient({
    uri: "https://8pxnxmudye.us-west-2.awsapprunner.com",
    cache: new InMemoryCache(),
  });

  return (
    <ApolloProvider client={client}>
      <div className="min-h-full">
        <div className="bg-indigo-600 pb-32">
          <nav className="bg-indigo-600 border-b border-indigo-300 border-opacity-25 lg:border-none">
            <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
              <div className="relative h-16 flex items-center justify-between lg:border-b lg:border-indigo-400 lg:border-opacity-25">
                <div className="px-2 flex items-center lg:px-0">
                  <div className="flex-shrink-0">
                    <img className="block h-8 w-8" src={logo} alt="Workflow" />
                  </div>
                  <div className="ml-4 lg:ml-10">
                    <div className="flex space-x-2 md:space-x-4">
                      {tabs.map((item) => (
                        <button
                          key={item}
                          onClick={(e) => {
                            e.preventDefault();
                            setTab(item);
                          }}
                          className={classNames(
                            item === tab
                              ? "bg-indigo-700 text-white"
                              : "text-white hover:bg-indigo-500 hover:bg-opacity-75",
                            "rounded-md py-2 px-3 text-sm font-medium capitalize",
                          )}
                          aria-current={item === tab ? "page" : undefined}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          {tab === "election" && <ElectionHeader />}
          {tab === "membership" && (
            <MembersHeader search={search} setSearch={setSearch} />
          )}
        </div>

        <main className="-mt-32">
          <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
            {tab === "election" && <Election />}
            {tab === "membership" && <Members search={search} />}
          </div>
        </main>
      </div>
    </ApolloProvider>
  );
}
